import React from 'react';
import { workflowSteps } from '../../data/mockData';

const WorkflowProgress = ({ workflowStep }) => (
  <div style={{
    display: 'flex',
    gap: '4px',
    padding: '20px 32px',
    backgroundColor: '#1a1a2e',
    borderBottom: '1px solid #2d2d44'
  }}>
    {workflowSteps.map((step, idx) => (
      <div key={step.id} style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          flex: 1
        }}>
          <div style={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: idx <= workflowStep ? '#6366f1' : '#374151',
            color: idx <= workflowStep ? 'white' : '#9ca3af',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '600',
            fontSize: 13,
            transition: 'all 0.3s ease'
          }}>
            {idx < workflowStep ? '\u2713' : idx + 1}
          </div>
          <span style={{
            marginTop: 8,
            fontSize: 11,
            color: idx <= workflowStep ? '#e5e7eb' : '#6b7280',
            fontWeight: idx === workflowStep ? '600' : '400',
            textAlign: 'center'
          }}>
            {step.name}
          </span>
        </div>
        {idx < workflowSteps.length - 1 && (
          <div style={{
            height: 2,
            flex: 1,
            backgroundColor: idx < workflowStep ? '#6366f1' : '#374151',
            marginTop: -20,
            transition: 'background-color 0.3s ease'
          }} />
        )}
      </div>
    ))}
  </div>
);

export default WorkflowProgress;
